module.exports = __webpack_public_path__ + "static/media/TeamMember_elRoundimage_812940.1620bb32.png";